import Typography from "@/components/typography/Typography"
import { useBreakpoint } from "@/hooks/useBreakpoint"
import { FC } from "react"
import "./StepCard.less"

import lineConnector from "./assets/line00.svg"
import straightLineConnector from "./assets/streight-line.svg"

const { Paragraph } = Typography

import calendarBlank from "./assets/CalendarBlank.svg"
import checkSquareOffset from "./assets/CheckSquareOffset.svg"
import circleTick from "./assets/circle-tick.svg"
import gear from "./assets/gear.svg"

export const STEP_ICONS_MAP = {
  calendarBlank,
  checkSquareOffset,
  circleTick,
  gear,
} as const

export type StepIconKey = keyof typeof STEP_ICONS_MAP

type Props = {
  icon: StepIconKey
  title: string
  description: string
  numberOfStep?: number
  line?: boolean
}

const StepCard: FC<Props> = ({ icon, title, description, numberOfStep, line = false }) => {
  const { xxl, xl, lg, md, sm, xs } = useBreakpoint()

  return (
    <div className={"step-card-wrapper"}>
      <div className={"hex-icon-wrapper"}>
        <div className={"hex-icon-shape"}>
          <div className={"icon-wrapper"}>
            <img src={icon} alt={""} />
          </div>
        </div>
        {numberOfStep && (
          <div className={"step-orange-circle-ext-wrapper"}>
            {line && (
              <div className={"line01-connector-wrapper"}>
                <img src={xxl || xl || lg ? lineConnector : straightLineConnector} alt={""} />
              </div>
            )}
            <div className={"step-orange-circle-wrapper"}>
              <div className={"text-wrapper"}>{numberOfStep}</div>
            </div>
          </div>
        )}
      </div>

      <div className={"content-wrapper"}>
        <Paragraph
          size={xxl || xl || lg || md ? "lg" : "md"}
          weight={"w900"}
          color={"white"}
          centered={!(xxl || xl || lg || md || sm)}
        >
          {title}
        </Paragraph>

        <Paragraph
          color={"website-secondary"}
          size={xxl || xl || lg || md ? "md" : "sm"}
          lh={"lh-lg"}
          centered={!(xxl || xl || lg || md || sm)}
        >
          {description}
        </Paragraph>
      </div>
    </div>
  )
}

export default StepCard
